<template>
  <button class="btn-media-tall" @click.stop.prevent="toggle()">
    <svg-play v-if="!playing" custom-class="btn-media-tall__icon-left"></svg-play>
    <svg-playing v-if="playing" custom-class="btn-media-tall__icon-left"></svg-playing>
    {{ buttonContent }}
    <audio ref="soundbiteaudio">
      <source :src="audio" :type="audioType">
      Your browser does not support the audio tag.
    </audio>
  </button>
</template>
<script>
import SvgPlay from './Svg/Play'
import SvgPlaying from './Svg/Playing'

export default {
  data: () => ({
    player: null,
    players: null,
    playing: false
  }),
  props: {
    audio: {
      type: String,
      required: true
    },
    audioType: {
      type: String,
      required: true
    },
    buttonContent: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.player = this.$refs.soundbiteaudio
    this.players = document.getElementsByTagName('audio')
    this.player.onpause = () => {
      this.playing = false
    }
    this.player.onplay = () => {
      this.playing = true
    }

  },
  components: {
    'svg-play': SvgPlay,
    'svg-playing': SvgPlaying
  },
  computed: {},
  methods: {
    toggle() {
      if (this.player.paused) {
        for(var i = 0, len = this.players.length; i < len;i++){
          this.players[i].pause();
        }
        this.player.play()
      } else {
        this.player.pause()
      }


    }
  }
}
</script>
